import jwt_decode from 'jwt-decode';
import { useEffect, useState } from 'react';
import { useLocalStorage } from '~/Hooks';

export const useToken = () => {
  const [decoded, setDecoded] = useState(null);
  const { accessToken } = useLocalStorage();

  useEffect(() => {
    if (accessToken) {
      setDecoded(jwt_decode(accessToken));
    }
  }, [accessToken]);

  return {
    decoded,
    isAdmin: (decoded as any)?.user_type === 'admin',
  };
};
